module.exports = __webpack_public_path__ + "static/sport/bgi-pc.7156b89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sinh/bgi-pc.jpg
// module id = jFlY
// module chunks = 0